import React from 'react';
import Image from 'next/image';
import { logCommonView } from '@/lib/service';
import { EventSource } from '@/shared/constants/event';
import { CatalogCompany } from '@/shared/types/catalog';
import './index.less';
import { useCreateAccountProvider } from '@/lib/context';
import { CHAT_WITH_FACTORY_DESCRIPTION } from '@/shared/constants/sourcing-marketplace';
import { getCreatorHubSupplierProfilePagePath } from '@/shared/utils/sourcing-marketplace-util';

interface IProps {
  supplier: CatalogCompany;
}

const CreateCustomProductCard = ({ supplier }: IProps) => {
  const { showSignupDialogFromSourcing } = useCreateAccountProvider();

  const clickCard = () => {
    showSignupDialogFromSourcing(
      CHAT_WITH_FACTORY_DESCRIPTION,
      getCreatorHubSupplierProfilePagePath(supplier.id),
      'factory_details_page',
    );
  };

  return (
    <div
      className="create-custom-product-card"
      onClick={() => {
        clickCard();
        logCommonView(EventSource.SUPPLIER_PROFILE, 'create_custom_product_card');
      }}
    >
      <div className="image-container">
        <Image src="/images/sourcing/create-custom-product.svg" width={75} height={75} alt="create custom product" />
      </div>
      <div className="text">
        <div className="top">
          <span className="title">Don't see what you're looking for?</span>
          <span className="subtitle">This supplier can work on custom requests.</span>
        </div>
        <div className="chat-factory-btn">
          <Image src="/images/sourcing/chat-with-supplier.svg" width={12} height={12} alt="chat supplier" />
          <span>Chat with the supplier</span>
        </div>
      </div>
    </div>
  );
};

export default CreateCustomProductCard;
